import React, { useRef } from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import indiaLogo from "./images/india-logo.svg";
import indiaLogoV2 from "./images/india-logo-v2.svg";
import { NUMBER } from "../../../constants/app-constants";

const ALPHANUMERIC = /[^a-z0-9]/gi;

const InputRegNoPlate = React.memo(({
    placeholder = "DL 01 AB12XX",
    isError,
    errorMessage,
    onChange,
    isChallan = false,
    isDisabled = false
}) => {
    const inputRef = useRef();

    const handleInput = (e) => {
        const input = inputRef.current;
        const raw = input.value.replace(/\s+/g, "");
        const isDeleting = e.nativeEvent.inputType?.startsWith("delete");

        let formatted = "";
        if (!isDeleting) {
            for (let i = 0; i < raw.length; i++) {
                formatted += raw[i];
                if (i === NUMBER.ONE || i === NUMBER.THREE) formatted += " ";
            }
        }

        const updatedValue = isDeleting ? input.value : formatted;
        input.value = updatedValue;

        const deferSanitize = window.requestIdleCallback || window.requestAnimationFrame || window.setTimeout;
        deferSanitize(() => {
            const sanitizedVal = updatedValue.replace(ALPHANUMERIC, "");
            onChange(sanitizedVal);
        }, { timeout: 100 });
    };

    return (
        <div styleName={`${"styles.inputShift"} ${`styles.prefixImg`} ${isChallan ? "styles.challanImage" : ""} `} className="shrinkOnTouch">
            <img src={isChallan ? indiaLogoV2 : indiaLogo} />
            <input
                type={"text"}
                className="form-control"
                onInput={handleInput}
                ref={inputRef}
                placeholder={placeholder}
                autoComplete="off"
                inputMode="text"
                maxLength={15}
                disabled={isDisabled}
            />
            { !isDisabled &&
                <small styleName={`styles.error ${isError ? "styles.showError" : "styles.hideError"}`}>{errorMessage}</small>
            }
        </div>
    );
});

InputRegNoPlate.propTypes = {
    placeholder: PropTypes.string,
    isError: PropTypes.bool,
    errorMessage: PropTypes.string,
    onChange: PropTypes.func,
    isChallan: PropTypes.bool,
    maxLength: PropTypes.number,
    isDisabled: PropTypes.bool
};

export default InputRegNoPlate;
